(function($) {
"use strict";

/*------------------------------------------------------------------
[Table of contents]



-------------------------------------------------------------------*/

/*--------------------------------------------------------------
CUSTOM PRE DEFINE FUNCTION
------------------------------------------------------------*/
/* is_exist() */
jQuery.fn.is_exist = function(){
  return this.length;
}


$(function(){

/*--------------------------------------------------------------
OS MENU JS
--------------------------------------------------------------*/

$(".menu-bar").on("click", function () {
    $(".offcanves-menu, .offcanvas-overlay").addClass("active");
});
$(".close, .offcanvas-overlay").on("click", function () {
    $(".offcanves-menu, .offcanvas-overlay").removeClass("active");
});

/*--------------------------------------------------------------
LP EXTRA MENU INIT
--------------------------------------------------------------*/

if ($('a.arrow-btn, a.click-btn').length > 0) {
    $('a.arrow-btn, a.click-btn').on('click', function(e) {
          e.preventDefault();
          $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 700, 'linear');
      });
   }

/*--------------------------------------------------------------
COOKIES
--------------------------------------------------------------*/

if(localStorage.getItem('cookiesAccepted') == null){
	$(".cookies-section").removeClass("hide");
}else{
	$(".cookies-section").addClass("hide");
}

$(".cookies-btn").unbind("click");
$(".cookies-btn").bind("click",function(e){
	$.ajax({
	  type: "POST",
	  url: "/api/cookies/accept",
	  data: {Accept: true},
	  success: function(data){
		  if(JSON.parse(data).message.toLowerCase() == 'true'){
			localStorage.setItem('cookiesAccepted', "true");
			$(".cookies-section").hide("400");  
		  }else{
			$(".cookies-section").show("400");   
		  }
	  }
	});
	
	e.preventDefault();
});

/*--------------------------------------------------------------
KDG GALLERY MAGNIFIC POPUP JS
------------------------------------------------------------*/
var gallery_popup = $('.gallery-popup');
if(gallery_popup.is_exist()){
  $(gallery_popup).magnificPopup({
     // delegate: 'a',
      type: 'image',
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function(item) {
          return item.el.attr('title') + ' &middot; <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">image source</a>';
        }
      },
      gallery: {
        enabled: true
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function(element) {
          return element.find('img');
        }
      }

  });
}

/*--------------------------------------------------------------
FORM VALIDATION
--------------------------------------------------------------*/
$("input[name='key']").each(function() {
  $(this).val($(this).attr("key"));
});
$("form").submit(function(e){
	if(!$(this).find(".privacy-disclaimer").is(':checked')){
	  $(this).find(".alert").removeClass("hide");
	  e.preventDefault();
	}
});

});/*End document ready*/


$(window).on("resize", function(){

}); // end window resize


$(window).on("load" ,function(){


}); // End window LODE


  var wow = new WOW({
      mobile: false,       // default
      tablet:false
    });
    wow.init();



})(jQuery);









